var hideAddButton = function hideAddButton(count, index) {
  return index !== count - 1;
};
export default hideAddButton;